import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Divider,
  FormHelperText,
  Grid,
} from "@mui/material";
import LoadingBar from "../../../App/Components/LoadingBar/LoadingBar";
import DropdownComponent from "../../../App/Components/Dropdown/DropdownComponent";
import { editPermissions, getUsers } from "../../../App/Services/UserService";
import RightsSection from "./RightsSection";
import { callAPI } from "../../../App/Helpers/callApi";
import { useRoleSelectionState } from "../State/RoleSelectionState";
import { CRMRoles } from "../../../App/Enums/CRMRoles";
import AutoCompleteComponent from "../../../App/Components/AutoComplete/AutoComplete";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
}));

export default function RoleModal({
  user,
  role,
  rights,
  crmRole,
  editCrmOnly,
  canEditCrmRoles,
  setModal,
  setShowSignifier,
  setResponseMessage,
  setShowError,
  setTableData,
}) {
  const classes = useStyles();
  const roleState = useRoleSelectionState();
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    if (role != null) {
      for (var i in roleState.getters.roles) {
        if (roleState.getters.roles[i].id === role.id) {
          roleState.setters.setSelectedRole(roleState.getters.roles[i]);
        }
      }
    }
    roleState.setters.setSelectedCRMRole(CRMRoles[crmRole]);
  }, [crmRole, role, roleState.getters.roles]);

  useEffect(() => {
    roleState.setters.setSelectedRights(rights);
  }, [rights]);

  const saveRole = () => {
    callAPI(
      editPermissions(
        user?.id,
        roleState.getters.selectedRole?.id,
        roleState.getters.selectedRights === null
          ? ""
          : roleState.getters.selectedRights,
        roleState.getters.selectedCRMRole.value
      ),
      "Role saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getUsers(
        roleState.getters.isSuperAdmin,
        roleState.getters.isAdmin,
        roleState.getters.isLightAdmin,
        roleState.getters.isClientAdmin
      ).then((response) => {
        setTableData(response);
      });
      setModal(false);
    });
  };

  return (
    <div className={classes.root}>
      <LoadingBar loading={processing} />
      <Grid>
        <Card>
          <CardContent>
            <FormHelperText style={{ fontWeight: "bold" }}>
              Edit User Permissions
            </FormHelperText>
            <Grid container spacing={1}>
              {roleState.getters.selectedClient.hasCareers && !editCrmOnly ? (
                <>
                  <Grid item xs={12} sm={12}>
                    <Divider></Divider>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <AutoCompleteComponent
                      dropdownItems={roleState.handlers.filterRoles()}
                      propertyName="name"
                      label="Careers Role"
                      onChange={(e, value) =>
                        roleState.setters.setSelectedRole(value)
                      }
                      currValue={roleState.getters.selectedRole}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <RightsSection
                      roleId={roleState.getters.selectedRole?.id?.toUpperCase()}
                      rights={roleState.getters.selectedRights}
                      setRights={roleState.setters.setSelectedRights}
                    />
                  </Grid>
                </>
              ) : null}
              {canEditCrmRoles ? (
                <>
                  <Grid item xs={12} sm={12}>
                    <Divider></Divider>
                    <br></br>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <DropdownComponent
                      currValue={roleState.getters.selectedCRMRole}
                      items={CRMRoles}
                      property="name"
                      title="CRM Role"
                      handleChange={(value) =>
                        roleState.setters.setSelectedCRMRole(value)
                      }
                      multi={false}
                    />
                  </Grid>
                </>
              ) : null}
              <Grid
                container
                justifyContent="flex-end"
                direction="row"
                style={{ marginRight: "10px" }}
              >
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ color: "#82B288", marginTop: "20px" }}
                    type="submit"
                    variant="outlined"
                    fullWidth
                    onClick={() => setModal(false)}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ marginTop: "20px", marginLeft: "10px" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => saveRole()}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
